export enum ToastMessageOption {
    Error = "Cập nhật thông tin thất bại!",
    Success = "Cập nhật thông tin thành công.",
    Info = "Yêu cầu đang được thực hiện."
}